import { render, staticRenderFns } from "./ConvocationFormManage.vue?vue&type=template&id=17d66ba7&scoped=true&"
import script from "./ConvocationFormManage.vue?vue&type=script&lang=js&"
export * from "./ConvocationFormManage.vue?vue&type=script&lang=js&"
import style0 from "./ConvocationFormManage.vue?vue&type=style&index=0&id=17d66ba7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d66ba7",
  null
  
)

export default component.exports